namespace Teva {
    export class Storage {
        static Cookie_Set(Name, Value, Days): void {
            var Seconds = Days * 24 * 60 * 60;
            document.cookie = Name + "=" + Value + "; domain=.sumit.co.il; path=/; max-age=" + Seconds;
        }
        static Cookie_Get(Name): string {
            var NameWithEquals = Name + "=";
            var Cookies = document.cookie.split(';');
            for (var i = 0; i < Cookies.length; i++) {
                var Cookie = Cookies[i];
                while (Cookie.charAt(0) == ' ')
                    Cookie = Cookie.substring(1);
                if (Cookie.indexOf(NameWithEquals) != -1)
                    return Cookie.substring(NameWithEquals.length, Cookie.length);
            }
            return "";
        }

        static LocalStorage_Supported() {
            try {
                return localStorage != null;
            }
            catch {
                return false;
            }
        }
        static LocalStorage_Set(Key, Value, Serialize = true): void {
            if (!Storage.LocalStorage_Supported())
                return;

            if (Serialize && Value != null)
                Value = JSON.stringify(Value);
            if (Value == null || Value == "")
                localStorage.removeItem(Key);
            else
                localStorage.setItem(Key, Value);
        }
        static LocalStorage_Get(Key, Deserialize = true): any {
            if (!Storage.LocalStorage_Supported())
                return;
            var ToReturn = localStorage.getItem(Key);
            if (Deserialize && ToReturn != null)
                return JSON.parse(ToReturn);
            return ToReturn;
        }

        static QueryString_Get(Key) {
            var URL = window.location.href;
            Key = Key.replace(/[\[\]]/g, "\\$&");
            var Regex = new RegExp("[?&]" + Key + "(=([^&#]*)|&|#|$)", "i");
            var Results = Regex.exec(URL);
            if (!Results || !Results[2])
                return null;
            return decodeURIComponent(Results[2].replace(/\+/g, " "));
        }
    }
}